import React from 'react';

/**
 * PageHeader Component
 * 
 * A premium, full-width hero header for pages.
 * 
 * @param {Object} props
 * @param {string} props.title - The main heading text
 * @param {string} props.subtitle - Descriptive subtext
 * @param {React.ReactNode} props.extra - Optional extra content (actions, stats, etc.)
 */
const PageHeader = ({
    title,
    subtitle,
    extra
}) => {
    return (
        <div className="pt-10 pb-6 mb-8 border-b border-gray-100">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                    <div>
                        <h1 className="text-xl md:text-2xl font-bold text-gray-900 tracking-tight">
                            {title}
                        </h1>
                        {subtitle && (
                            <p className="mt-0.5 text-sm md:text-base text-gray-500 max-w-2xl font-medium">
                                {subtitle}
                            </p>
                        )}
                    </div>

                    {extra && (
                        <div className="flex items-center">
                            {extra}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PageHeader;
